import React from 'react';
import './FormTopBarW.css';
import green from "../images/MzCare_Logo-02.svg"

function FormTopBarW () {
  return (
    <div className="placeTopW">
         {/* <div> */}
        <img className='logoPlacementW'src={green}>
        </img>
        {/* </div> */}
      </div>
  );
};

export default FormTopBarW;